/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const headerConfig = {
  identifier: {
    title: 'Login to your account',
    logo: 'https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png',
  },
  password: {
    title: 'Enter your password',
    logo: 'https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png',
  },
  otp: {
    logo: 'https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png',
    iconURL:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/email-new.png',
    title: 'Enter your One Time Password',
    subHeadingText:
      'We have emailed OTP (One Time PIN) to your registered email id ${email}. Please check and enter below.',
  },
};
